<h1 mat-dialog-title>Documents</h1>

<div mat-dialog-content>

    <table mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef> Nom du document </th>
            <td mat-cell *matCellDef="let document"> {{document.fileName}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let document">
                <button mat-icon-button color="primary" (click)="onDownloadDocument(document)">
                    <mat-icon>download</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

</div>

<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onDownloadAll()" [disabled]="documents.length === 0">Tout
        télécharger</button>
</div>